import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Drawer } from 'antd';
import { Btn, BtnsBox } from '../../../../../../../../common/ui/Common2';
import Modal from '../../../../../../../../common/ui/Modal/Modal';
import getTableColumns from './TableConfig';
import ReportTable from './ReportTable';
import ShowText from './ShowText';
import { useToggle } from '../../../../../../../../logic/hooks/useToggle';
import TableTitle from '../../DetailedReport/TableTitle';

function RequestTable(props) {
  const { pagination } = props;
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [columnsFiltersList, setColumnsFiltersList] = useState({});
  const [modalData, setModalData] = useState({});
  const [isOpen, toggleOpen] = useToggle(false);
  const [modalWndtitle, setModalWndtitle] = useState('');
  // const [downloadLink, setDownloadLink] = useState();
  // const [downloadPhotoName, setDownloadPhotoName] = useState();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerData, setDrawerData] = useState(null);

  const [query, setQuery] = useState();

  const fetchTableData = async () => {
    setLoading(true);
    // const res = await SqlQuery(pagination.startDate, pagination.endDate);

    const res = await axios.get('/api/reports/appealsReport/', {
      params: {
        token: window.localStorage.getItem('token'),
        startDate: pagination.startDate,
        endDate: pagination.endDate,
      },
    });

    console.log('res ==== ', res);

    const uniqueSource = [];
    const uniqueOperetors = [];
    const sourceList = [];
    const operatorList = [];

    res.data.data.forEach((el) => {
      if (!uniqueSource.includes(el.source)) uniqueSource.push(el.source);
      if (!uniqueOperetors.includes(el.fio)) uniqueOperetors.push(el.fio);
    });

    uniqueSource.forEach((el) => {
      sourceList.push({ text: el, value: el });
    });

    uniqueOperetors.forEach((el) => {
      operatorList.push({ text: el, value: el });
    });
    setColumnsFiltersList({ operatorList, sourceList });
    setTableData(res.data.data);
    setQuery(res.queryExport);
    setLoading(false);
  };

  const handleTableIcon = (name, row) => {
    // if (name === 'photo') {
    //   setModalData(
    //     <img style={{ width: '100%' }} src={row.photo_b64} alt="" />,
    //   );
    //   setModalWndtitle('Фотография посетителя');
    //   setDownloadLink(row.photo_b64);
    //   setDownloadPhotoName(`Photo-session${row.id}`);
    //   toggleOpen();
    // } else
    if (name === 'micro') {
      setModalData(
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <audio style={{ width: '100%' }} controls>
          <source src={row.audiorecordpath} />
        </audio>,
      );
      setModalWndtitle('Аудио запись');
      // setDownloadLink(row.audiorecordpath);
      toggleOpen();
    } else if (name === 'video') {
      console.log('row.videorecordpath === ', row.videorecordpath);
      setModalData(
        <video controls style={{ width: '100%' }}>
          <source src={row.videorecordpath} />
        </video>,
      );
      setModalWndtitle('Видео запись');
      // setDownloadLink(row.videorecordpath);
      toggleOpen();
    } else if (name === 'comment') {
      setDrawerData(row.extraData);
      setDrawerOpen(true);
    }
  };

  const resetModal = () => {
    toggleOpen();
  };

  useEffect(() => {
    fetchTableData();
  }, [pagination]);

  // const photoOfVisiter = modalWndtitle === 'Фотография посетителя'
  //   ? (
  //     <a href={downloadLink} download={downloadPhotoName}>
  //       <Btn valid margin="0 25px 0 0" bg="green">Сохранить</Btn>
  //     </a>
  //   )
  //   : (
  //     <a href={downloadLink} download>
  //       <Btn valid margin="0 25px 0 0" bg="green">Сохранить</Btn>
  //     </a>
  //   );

  return (
    <div>

      <Modal title={modalWndtitle} isOpen={isOpen} toggleOpen={resetModal}>
        {modalData}
        <BtnsBox>
          {modalWndtitle === 'Комментарий посетителя' ? null : null}
          <Btn cancel onClick={() => toggleOpen()} bg="accent">Закрыть</Btn>
        </BtnsBox>
      </Modal>

      <TableTitle
        ReportParams={
          {
            items: tableData,
            query,
            TableConfig: {
              columns: getTableColumns(columnsFiltersList, handleTableIcon),
            },
            TebleType: 'RequestTable',
          }
        }
        name="Оценка качества"
        type="RequestTable"
        pagination={pagination}
      />

      <ReportTable
        rowKey="id"
        columns={getTableColumns(columnsFiltersList, handleTableIcon)}
        data={tableData}
        loading={loading}
      />

      <Drawer
        title="Комментарий посетителя"
        placement="right"
        width={500}
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
      >
        <ShowText item={drawerData} />
      </Drawer>

    </div>
  );
}

export default RequestTable;
